import Typography from "@material-ui/core/Typography";
import { type SetterOrUpdater, useRecoilState, useRecoilValue } from "recoil";
import CustomSelect from "../components/CustomSelect";
import {
	getPeriodOptions,
	getPeriodOptionsWithHourDisabled,
} from "../constants";
import { isAdminState, localeState, periodState } from "../store";
import { Grid } from "@material-ui/core";
import type { SelectOptions } from "../types";

export default function Period() {
	const [period, setPeriod] = useRecoilState(periodState);
	const isAdmin = useRecoilValue(isAdminState);
	const resolvedLocale = useRecoilValue(localeState);

	return (
		<>
			<Grid container>
				<Grid item lg={12} md={12} sm={12} xs={12}>
					<Typography>{resolvedLocale.everyText}</Typography>
					<CustomSelect
						single
						disableClearable
						options={
							isAdmin
								? getPeriodOptions(resolvedLocale.periodOptions)
								: getPeriodOptionsWithHourDisabled(resolvedLocale.periodOptions)
						}
						label={resolvedLocale.periodLabel}
						value={period}
						setValue={
							setPeriod as SetterOrUpdater<SelectOptions | SelectOptions[]>
						}
						multiple={false}
					/>
				</Grid>
			</Grid>
		</>
	);
}
